import axiosInstance from "../../utils/config/config";

export const getUserById = () => async (dispatch) => {
  try {
    dispatch({
      type: "userByIdRequest",
    });
    const { data } = await axiosInstance.get(`/user/profile`);
    dispatch({
      type: "userByIdSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "userByIdFailure",
      payload: error,
    });
  }
};

export const sendInvite = async () => {
  try {
    const response = await axiosInstance.post(`/user/inviteUsers`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPractioner = () => async (dispatch) => {
  try {
    dispatch({
      type: "practionerRequest",
    });
    const { data } = await axiosInstance.get(`user/practitioner`);
    dispatch({
      type: "practionerSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "practionerFailure",
      payload: error,
    });
  }
};
export const getIPHCPractioner = () => async (dispatch) => {
  try {
    dispatch({
      type: "iphcPractitionerRequest",
    });
    const { data } = await axiosInstance.get(`user/iphc-practitioner`);
    dispatch({
      type: "iphcPractitionerSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "iphcPractitionerFailure",
      payload: error.response?.data?.message || error.message,
    });
  }
};
export const getPatient = (userId) => async (dispatch) => {
  try {
    dispatch({ type: "patientRequest" });
    const { data } = await axiosInstance.post(`user/patient-ghl`, { userId });
    dispatch({
      type: "patientSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "patientFailure",
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const getWheelOfLife = () => async (dispatch) => {
  try {
    dispatch({
      type: "wheelOfLifeRequest",
    });
    const { data } = await axiosInstance.get(`user/wheelOfLife/all`);
    dispatch({
      type: "wheelOfLifeSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "wheelOfLifeFailure",
      payload: error,
    });
  }
};

export const clearUser = () => async (dispatch) => {
  dispatch({
    type: "clearUserData",
  });
};
